import { MissionsActions, MissionsType } from "../types/MissionsTypes"
import { missionsReducer } from "./Missions"

export type InitialStateType = {
    missions: MissionsType
}

export const mainReducer = ({ missions }: InitialStateType, action: MissionsActions): InitialStateType => ({
    missions: missionsReducer(missions, action as MissionsActions),
})
